export default "__VITE_ASSET__Sp6EZZ9C__"